{
  "$generated": "scripts/import-price-sheets.mjs - do not hand-edit tables; edit the source sheet and re-run.",
  "$assumption": "Quantity = finished pieces and unit = price per finished piece. Not yet confirmed by NMS (see docs/open-questions.md).",
  "id": "printing",
  "label": "Flat Printing (flyers, cards, postcards)",
  "type": "tiered-table",
  "quantityLabel": "Quantity",
  "unitLabel": "piece",
  "capAtNextBreak": true,
  "aboveMax": "quote",
  "options": [
    {
      "id": "stock",
      "label": "Paper",
      "choices": [
        {
          "id": "20-bond-8-5x11",
          "label": "20# Bond 8.5x11"
        },
        {
          "id": "20-bond-11x17",
          "label": "20# Bond 11x17"
        },
        {
          "id": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
          "label": "60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18"
        },
        {
          "id": "100-cover-or-text-matte-or-gloss-12x18",
          "label": "100# Cover or Text - Matte or Gloss 12x18"
        },
        {
          "id": "130-cover-matte-or-gloss-12x18",
          "label": "130# Cover - Matte or Gloss 12x18"
        },
        {
          "id": "14pt-12x18",
          "label": "14pt – 12x18"
        },
        {
          "id": "16pt-12x18",
          "label": "16pt – 12x18"
        }
      ]
    },
    {
      "id": "ink",
      "label": "Ink",
      "choices": [
        {
          "id": "1/0",
          "label": "1/0: black, one side"
        },
        {
          "id": "1/1",
          "label": "1/1: black, both sides"
        },
        {
          "id": "4/0",
          "label": "4/0: full color, one side"
        },
        {
          "id": "4/1",
          "label": "4/1: color front, black back"
        },
        {
          "id": "4/4",
          "label": "4/4: full color, both sides"
        }
      ]
    },
    {
      "id": "up",
      "label": "Pieces per sheet (N-up)",
      "choices": [
        {
          "id": "1",
          "label": "1-up"
        },
        {
          "id": "2",
          "label": "2-up"
        },
        {
          "id": "3",
          "label": "3-up"
        },
        {
          "id": "4",
          "label": "4-up"
        },
        {
          "id": "8",
          "label": "8-up"
        },
        {
          "id": "10",
          "label": "10-up"
        },
        {
          "id": "12",
          "label": "12-up"
        }
      ]
    }
  ],
  "tables": [
    {
      "when": {
        "up": "1",
        "stock": "20-bond-8-5x11",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.62
        },
        {
          "qty": 100,
          "unit": 0.97
        },
        {
          "qty": 250,
          "unit": 0.58
        },
        {
          "qty": 500,
          "unit": 0.45
        },
        {
          "qty": 1000,
          "unit": 0.39
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"20# Bond 8.5x11\" 1/0"
    },
    {
      "when": {
        "up": "1",
        "stock": "20-bond-8-5x11",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.72
        },
        {
          "qty": 100,
          "unit": 1.07
        },
        {
          "qty": 250,
          "unit": 0.68
        },
        {
          "qty": 500,
          "unit": 0.55
        },
        {
          "qty": 1000,
          "unit": 0.49
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"20# Bond 8.5x11\" 1/1"
    },
    {
      "when": {
        "up": "1",
        "stock": "20-bond-8-5x11",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.68
        },
        {
          "qty": 100,
          "unit": 1.03
        },
        {
          "qty": 250,
          "unit": 0.64
        },
        {
          "qty": 500,
          "unit": 0.51
        },
        {
          "qty": 1000,
          "unit": 0.45
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"20# Bond 8.5x11\" 4/0"
    },
    {
      "when": {
        "up": "1",
        "stock": "20-bond-8-5x11",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.78
        },
        {
          "qty": 100,
          "unit": 1.13
        },
        {
          "qty": 250,
          "unit": 0.74
        },
        {
          "qty": 500,
          "unit": 0.61
        },
        {
          "qty": 1000,
          "unit": 0.55
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"20# Bond 8.5x11\" 4/1"
    },
    {
      "when": {
        "up": "1",
        "stock": "20-bond-8-5x11",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.84
        },
        {
          "qty": 100,
          "unit": 1.19
        },
        {
          "qty": 250,
          "unit": 0.8
        },
        {
          "qty": 500,
          "unit": 0.67
        },
        {
          "qty": 1000,
          "unit": 0.61
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"20# Bond 8.5x11\" 4/4"
    },
    {
      "when": {
        "up": "1",
        "stock": "20-bond-11x17",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.67
        },
        {
          "qty": 100,
          "unit": 1.02
        },
        {
          "qty": 250,
          "unit": 0.63
        },
        {
          "qty": 500,
          "unit": 0.5
        },
        {
          "qty": 1000,
          "unit": 0.44
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"20# Bond 11x17\" 1/0"
    },
    {
      "when": {
        "up": "1",
        "stock": "20-bond-11x17",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.82
        },
        {
          "qty": 100,
          "unit": 1.17
        },
        {
          "qty": 250,
          "unit": 0.78
        },
        {
          "qty": 500,
          "unit": 0.65
        },
        {
          "qty": 1000,
          "unit": 0.59
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"20# Bond 11x17\" 1/1"
    },
    {
      "when": {
        "up": "1",
        "stock": "20-bond-11x17",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.73
        },
        {
          "qty": 100,
          "unit": 1.08
        },
        {
          "qty": 250,
          "unit": 0.69
        },
        {
          "qty": 500,
          "unit": 0.56
        },
        {
          "qty": 1000,
          "unit": 0.5
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"20# Bond 11x17\" 4/0"
    },
    {
      "when": {
        "up": "1",
        "stock": "20-bond-11x17",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.88
        },
        {
          "qty": 100,
          "unit": 1.23
        },
        {
          "qty": 250,
          "unit": 0.84
        },
        {
          "qty": 500,
          "unit": 0.71
        },
        {
          "qty": 1000,
          "unit": 0.65
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"20# Bond 11x17\" 4/1"
    },
    {
      "when": {
        "up": "1",
        "stock": "20-bond-11x17",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.94
        },
        {
          "qty": 100,
          "unit": 1.29
        },
        {
          "qty": 250,
          "unit": 0.9
        },
        {
          "qty": 500,
          "unit": 0.77
        },
        {
          "qty": 1000,
          "unit": 0.71
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"20# Bond 11x17\" 4/4"
    },
    {
      "when": {
        "up": "1",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.72
        },
        {
          "qty": 100,
          "unit": 1.07
        },
        {
          "qty": 250,
          "unit": 0.68
        },
        {
          "qty": 500,
          "unit": 0.55
        },
        {
          "qty": 1000,
          "unit": 0.49
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "1",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.92
        },
        {
          "qty": 100,
          "unit": 1.27
        },
        {
          "qty": 250,
          "unit": 0.88
        },
        {
          "qty": 500,
          "unit": 0.75
        },
        {
          "qty": 1000,
          "unit": 0.69
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "1",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.78
        },
        {
          "qty": 100,
          "unit": 1.13
        },
        {
          "qty": 250,
          "unit": 0.74
        },
        {
          "qty": 500,
          "unit": 0.61
        },
        {
          "qty": 1000,
          "unit": 0.55
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "1",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.98
        },
        {
          "qty": 100,
          "unit": 1.33
        },
        {
          "qty": 250,
          "unit": 0.94
        },
        {
          "qty": 500,
          "unit": 0.81
        },
        {
          "qty": 1000,
          "unit": 0.75
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "1",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.04
        },
        {
          "qty": 100,
          "unit": 1.39
        },
        {
          "qty": 250,
          "unit": 1
        },
        {
          "qty": 500,
          "unit": 0.87
        },
        {
          "qty": 1000,
          "unit": 0.81
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "1",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.75
        },
        {
          "qty": 100,
          "unit": 1.1
        },
        {
          "qty": 250,
          "unit": 0.71
        },
        {
          "qty": 500,
          "unit": 0.58
        },
        {
          "qty": 1000,
          "unit": 0.52
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "1",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.98
        },
        {
          "qty": 100,
          "unit": 1.33
        },
        {
          "qty": 250,
          "unit": 0.94
        },
        {
          "qty": 500,
          "unit": 0.81
        },
        {
          "qty": 1000,
          "unit": 0.75
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "1",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.81
        },
        {
          "qty": 100,
          "unit": 1.16
        },
        {
          "qty": 250,
          "unit": 0.77
        },
        {
          "qty": 500,
          "unit": 0.64
        },
        {
          "qty": 1000,
          "unit": 0.58
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "1",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.04
        },
        {
          "qty": 100,
          "unit": 1.39
        },
        {
          "qty": 250,
          "unit": 1
        },
        {
          "qty": 500,
          "unit": 0.87
        },
        {
          "qty": 1000,
          "unit": 0.81
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "1",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.1
        },
        {
          "qty": 100,
          "unit": 1.45
        },
        {
          "qty": 250,
          "unit": 1.06
        },
        {
          "qty": 500,
          "unit": 0.93
        },
        {
          "qty": 1000,
          "unit": 0.87
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "1",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.82
        },
        {
          "qty": 100,
          "unit": 1.17
        },
        {
          "qty": 250,
          "unit": 0.78
        },
        {
          "qty": 500,
          "unit": 0.65
        },
        {
          "qty": 1000,
          "unit": 0.59
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "1",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.12
        },
        {
          "qty": 100,
          "unit": 1.47
        },
        {
          "qty": 250,
          "unit": 1.08
        },
        {
          "qty": 500,
          "unit": 0.95
        },
        {
          "qty": 1000,
          "unit": 0.89
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "1",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.88
        },
        {
          "qty": 100,
          "unit": 1.23
        },
        {
          "qty": 250,
          "unit": 0.84
        },
        {
          "qty": 500,
          "unit": 0.71
        },
        {
          "qty": 1000,
          "unit": 0.65
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "1",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.18
        },
        {
          "qty": 100,
          "unit": 1.53
        },
        {
          "qty": 250,
          "unit": 1.14
        },
        {
          "qty": 500,
          "unit": 1.01
        },
        {
          "qty": 1000,
          "unit": 0.95
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "1",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.24
        },
        {
          "qty": 100,
          "unit": 1.59
        },
        {
          "qty": 250,
          "unit": 1.2
        },
        {
          "qty": 500,
          "unit": 1.07
        },
        {
          "qty": 1000,
          "unit": 1.01
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "1",
        "stock": "14pt-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.97
        },
        {
          "qty": 100,
          "unit": 1.32
        },
        {
          "qty": 250,
          "unit": 0.93
        },
        {
          "qty": 500,
          "unit": 0.8
        },
        {
          "qty": 1000,
          "unit": 0.74
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"14pt – 12x18\" 1/0"
    },
    {
      "when": {
        "up": "1",
        "stock": "14pt-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.42
        },
        {
          "qty": 100,
          "unit": 1.77
        },
        {
          "qty": 250,
          "unit": 1.38
        },
        {
          "qty": 500,
          "unit": 1.25
        },
        {
          "qty": 1000,
          "unit": 1.19
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"14pt – 12x18\" 1/1"
    },
    {
      "when": {
        "up": "1",
        "stock": "14pt-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.03
        },
        {
          "qty": 100,
          "unit": 1.38
        },
        {
          "qty": 250,
          "unit": 0.99
        },
        {
          "qty": 500,
          "unit": 0.86
        },
        {
          "qty": 1000,
          "unit": 0.8
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"14pt – 12x18\" 4/0"
    },
    {
      "when": {
        "up": "1",
        "stock": "14pt-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.48
        },
        {
          "qty": 100,
          "unit": 1.83
        },
        {
          "qty": 250,
          "unit": 1.44
        },
        {
          "qty": 500,
          "unit": 1.31
        },
        {
          "qty": 1000,
          "unit": 1.25
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"14pt – 12x18\" 4/1"
    },
    {
      "when": {
        "up": "1",
        "stock": "14pt-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.54
        },
        {
          "qty": 100,
          "unit": 1.89
        },
        {
          "qty": 250,
          "unit": 1.5
        },
        {
          "qty": 500,
          "unit": 1.37
        },
        {
          "qty": 1000,
          "unit": 1.31
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"14pt – 12x18\" 4/4"
    },
    {
      "when": {
        "up": "1",
        "stock": "16pt-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.07
        },
        {
          "qty": 100,
          "unit": 1.42
        },
        {
          "qty": 250,
          "unit": 1.03
        },
        {
          "qty": 500,
          "unit": 0.9
        },
        {
          "qty": 1000,
          "unit": 0.84
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"16pt – 12x18\" 1/0"
    },
    {
      "when": {
        "up": "1",
        "stock": "16pt-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.62
        },
        {
          "qty": 100,
          "unit": 1.97
        },
        {
          "qty": 250,
          "unit": 1.58
        },
        {
          "qty": 500,
          "unit": 1.45
        },
        {
          "qty": 1000,
          "unit": 1.39
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"16pt – 12x18\" 1/1"
    },
    {
      "when": {
        "up": "1",
        "stock": "16pt-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.13
        },
        {
          "qty": 100,
          "unit": 1.48
        },
        {
          "qty": 250,
          "unit": 1.09
        },
        {
          "qty": 500,
          "unit": 0.96
        },
        {
          "qty": 1000,
          "unit": 0.9
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"16pt – 12x18\" 4/0"
    },
    {
      "when": {
        "up": "1",
        "stock": "16pt-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.68
        },
        {
          "qty": 100,
          "unit": 2.03
        },
        {
          "qty": 250,
          "unit": 1.64
        },
        {
          "qty": 500,
          "unit": 1.51
        },
        {
          "qty": 1000,
          "unit": 1.45
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"16pt – 12x18\" 4/1"
    },
    {
      "when": {
        "up": "1",
        "stock": "16pt-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.74
        },
        {
          "qty": 100,
          "unit": 2.09
        },
        {
          "qty": 250,
          "unit": 1.7
        },
        {
          "qty": 500,
          "unit": 1.57
        },
        {
          "qty": 1000,
          "unit": 1.51
        }
      ],
      "source": "PRINTING/Bond Price Sheet 1-Up.docx: \"16pt – 12x18\" 4/4"
    },
    {
      "when": {
        "up": "10",
        "stock": "20-bond-8-5x11",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.33
        },
        {
          "qty": 100,
          "unit": 0.68
        },
        {
          "qty": 250,
          "unit": 0.29
        },
        {
          "qty": 500,
          "unit": 0.16
        },
        {
          "qty": 1000,
          "unit": 0.1
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"20# Bond 8.5x11\" 1/0"
    },
    {
      "when": {
        "up": "10",
        "stock": "20-bond-8-5x11",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.34
        },
        {
          "qty": 100,
          "unit": 0.69
        },
        {
          "qty": 250,
          "unit": 0.3
        },
        {
          "qty": 500,
          "unit": 0.17
        },
        {
          "qty": 1000,
          "unit": 0.11
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"20# Bond 8.5x11\" 1/1"
    },
    {
      "when": {
        "up": "10",
        "stock": "20-bond-8-5x11",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.34
        },
        {
          "qty": 100,
          "unit": 0.69
        },
        {
          "qty": 250,
          "unit": 0.3
        },
        {
          "qty": 500,
          "unit": 0.17
        },
        {
          "qty": 1000,
          "unit": 0.1
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"20# Bond 8.5x11\" 4/0"
    },
    {
      "when": {
        "up": "10",
        "stock": "20-bond-8-5x11",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.11
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"20# Bond 8.5x11\" 4/1"
    },
    {
      "when": {
        "up": "10",
        "stock": "20-bond-8-5x11",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.12
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"20# Bond 8.5x11\" 4/4"
    },
    {
      "when": {
        "up": "10",
        "stock": "20-bond-11x17",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.34
        },
        {
          "qty": 100,
          "unit": 0.69
        },
        {
          "qty": 250,
          "unit": 0.3
        },
        {
          "qty": 500,
          "unit": 0.17
        },
        {
          "qty": 1000,
          "unit": 0.1
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"20# Bond 11x17\" 1/0"
    },
    {
      "when": {
        "up": "10",
        "stock": "20-bond-11x17",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.12
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"20# Bond 11x17\" 1/1"
    },
    {
      "when": {
        "up": "10",
        "stock": "20-bond-11x17",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.34
        },
        {
          "qty": 100,
          "unit": 0.69
        },
        {
          "qty": 250,
          "unit": 0.3
        },
        {
          "qty": 500,
          "unit": 0.17
        },
        {
          "qty": 1000,
          "unit": 0.11
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"20# Bond 11x17\" 4/0"
    },
    {
      "when": {
        "up": "10",
        "stock": "20-bond-11x17",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.36
        },
        {
          "qty": 100,
          "unit": 0.71
        },
        {
          "qty": 250,
          "unit": 0.32
        },
        {
          "qty": 500,
          "unit": 0.19
        },
        {
          "qty": 1000,
          "unit": 0.12
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"20# Bond 11x17\" 4/1"
    },
    {
      "when": {
        "up": "10",
        "stock": "20-bond-11x17",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.36
        },
        {
          "qty": 100,
          "unit": 0.71
        },
        {
          "qty": 250,
          "unit": 0.32
        },
        {
          "qty": 500,
          "unit": 0.19
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"20# Bond 11x17\" 4/4"
    },
    {
      "when": {
        "up": "10",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.34
        },
        {
          "qty": 100,
          "unit": 0.69
        },
        {
          "qty": 250,
          "unit": 0.3
        },
        {
          "qty": 500,
          "unit": 0.17
        },
        {
          "qty": 1000,
          "unit": 0.11
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "10",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.36
        },
        {
          "qty": 100,
          "unit": 0.71
        },
        {
          "qty": 250,
          "unit": 0.32
        },
        {
          "qty": 500,
          "unit": 0.19
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "10",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.11
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "10",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.37
        },
        {
          "qty": 100,
          "unit": 0.72
        },
        {
          "qty": 250,
          "unit": 0.33
        },
        {
          "qty": 500,
          "unit": 0.2
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "10",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.37
        },
        {
          "qty": 100,
          "unit": 0.72
        },
        {
          "qty": 250,
          "unit": 0.33
        },
        {
          "qty": 500,
          "unit": 0.2
        },
        {
          "qty": 1000,
          "unit": 0.14
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "10",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.11
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "10",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.37
        },
        {
          "qty": 100,
          "unit": 0.72
        },
        {
          "qty": 250,
          "unit": 0.33
        },
        {
          "qty": 500,
          "unit": 0.2
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "10",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.12
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "10",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.37
        },
        {
          "qty": 100,
          "unit": 0.72
        },
        {
          "qty": 250,
          "unit": 0.33
        },
        {
          "qty": 500,
          "unit": 0.2
        },
        {
          "qty": 1000,
          "unit": 0.14
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "10",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.38
        },
        {
          "qty": 100,
          "unit": 0.73
        },
        {
          "qty": 250,
          "unit": 0.34
        },
        {
          "qty": 500,
          "unit": 0.21
        },
        {
          "qty": 1000,
          "unit": 0.15
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "10",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.12
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "10",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.38
        },
        {
          "qty": 100,
          "unit": 0.73
        },
        {
          "qty": 250,
          "unit": 0.34
        },
        {
          "qty": 500,
          "unit": 0.21
        },
        {
          "qty": 1000,
          "unit": 0.15
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "10",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.36
        },
        {
          "qty": 100,
          "unit": 0.71
        },
        {
          "qty": 250,
          "unit": 0.32
        },
        {
          "qty": 500,
          "unit": 0.19
        },
        {
          "qty": 1000,
          "unit": 0.12
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "10",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.39
        },
        {
          "qty": 100,
          "unit": 0.74
        },
        {
          "qty": 250,
          "unit": 0.35
        },
        {
          "qty": 500,
          "unit": 0.22
        },
        {
          "qty": 1000,
          "unit": 0.15
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "10",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.39
        },
        {
          "qty": 100,
          "unit": 0.74
        },
        {
          "qty": 250,
          "unit": 0.35
        },
        {
          "qty": 500,
          "unit": 0.22
        },
        {
          "qty": 1000,
          "unit": 0.16
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "10",
        "stock": "14pt-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.37
        },
        {
          "qty": 100,
          "unit": 0.72
        },
        {
          "qty": 250,
          "unit": 0.33
        },
        {
          "qty": 500,
          "unit": 0.2
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"14pt – 12x18\" 1/0"
    },
    {
      "when": {
        "up": "10",
        "stock": "14pt-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.41
        },
        {
          "qty": 100,
          "unit": 0.76
        },
        {
          "qty": 250,
          "unit": 0.37
        },
        {
          "qty": 500,
          "unit": 0.24
        },
        {
          "qty": 1000,
          "unit": 0.18
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"14pt – 12x18\" 1/1"
    },
    {
      "when": {
        "up": "10",
        "stock": "14pt-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.37
        },
        {
          "qty": 100,
          "unit": 0.72
        },
        {
          "qty": 250,
          "unit": 0.33
        },
        {
          "qty": 500,
          "unit": 0.2
        },
        {
          "qty": 1000,
          "unit": 0.14
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"14pt – 12x18\" 4/0"
    },
    {
      "when": {
        "up": "10",
        "stock": "14pt-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.42
        },
        {
          "qty": 100,
          "unit": 0.77
        },
        {
          "qty": 250,
          "unit": 0.38
        },
        {
          "qty": 500,
          "unit": 0.25
        },
        {
          "qty": 1000,
          "unit": 0.18
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"14pt – 12x18\" 4/1"
    },
    {
      "when": {
        "up": "10",
        "stock": "14pt-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.42
        },
        {
          "qty": 100,
          "unit": 0.77
        },
        {
          "qty": 250,
          "unit": 0.38
        },
        {
          "qty": 500,
          "unit": 0.25
        },
        {
          "qty": 1000,
          "unit": 0.19
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"14pt – 12x18\" 4/4"
    },
    {
      "when": {
        "up": "10",
        "stock": "16pt-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.38
        },
        {
          "qty": 100,
          "unit": 0.73
        },
        {
          "qty": 250,
          "unit": 0.34
        },
        {
          "qty": 500,
          "unit": 0.21
        },
        {
          "qty": 1000,
          "unit": 0.14
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"16pt – 12x18\" 1/0"
    },
    {
      "when": {
        "up": "10",
        "stock": "16pt-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.43
        },
        {
          "qty": 100,
          "unit": 0.78
        },
        {
          "qty": 250,
          "unit": 0.39
        },
        {
          "qty": 500,
          "unit": 0.26
        },
        {
          "qty": 1000,
          "unit": 0.2
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"16pt – 12x18\" 1/1"
    },
    {
      "when": {
        "up": "10",
        "stock": "16pt-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.38
        },
        {
          "qty": 100,
          "unit": 0.73
        },
        {
          "qty": 250,
          "unit": 0.34
        },
        {
          "qty": 500,
          "unit": 0.21
        },
        {
          "qty": 1000,
          "unit": 0.15
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"16pt – 12x18\" 4/0"
    },
    {
      "when": {
        "up": "10",
        "stock": "16pt-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.44
        },
        {
          "qty": 100,
          "unit": 0.79
        },
        {
          "qty": 250,
          "unit": 0.4
        },
        {
          "qty": 500,
          "unit": 0.27
        },
        {
          "qty": 1000,
          "unit": 0.2
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"16pt – 12x18\" 4/1"
    },
    {
      "when": {
        "up": "10",
        "stock": "16pt-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.44
        },
        {
          "qty": 100,
          "unit": 0.79
        },
        {
          "qty": 250,
          "unit": 0.4
        },
        {
          "qty": 500,
          "unit": 0.27
        },
        {
          "qty": 1000,
          "unit": 0.21
        }
      ],
      "source": "PRINTING/Bond Price Sheet 10-Up.docx: \"16pt – 12x18\" 4/4"
    },
    {
      "when": {
        "up": "12",
        "stock": "20-bond-11x17",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.33
        },
        {
          "qty": 100,
          "unit": 0.68
        },
        {
          "qty": 250,
          "unit": 0.29
        },
        {
          "qty": 500,
          "unit": 0.16
        },
        {
          "qty": 1000,
          "unit": 0.1
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"20# Bond 11x17\" 1/0"
    },
    {
      "when": {
        "up": "12",
        "stock": "20-bond-11x17",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.34
        },
        {
          "qty": 100,
          "unit": 0.69
        },
        {
          "qty": 250,
          "unit": 0.3
        },
        {
          "qty": 500,
          "unit": 0.17
        },
        {
          "qty": 1000,
          "unit": 0.1
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"20# Bond 11x17\" 1/1"
    },
    {
      "when": {
        "up": "12",
        "stock": "20-bond-11x17",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.34
        },
        {
          "qty": 100,
          "unit": 0.69
        },
        {
          "qty": 250,
          "unit": 0.3
        },
        {
          "qty": 500,
          "unit": 0.17
        },
        {
          "qty": 1000,
          "unit": 0.1
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"20# Bond 11x17\" 4/0"
    },
    {
      "when": {
        "up": "12",
        "stock": "20-bond-11x17",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.11
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"20# Bond 11x17\" 4/1"
    },
    {
      "when": {
        "up": "12",
        "stock": "20-bond-11x17",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.12
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"20# Bond 11x17\" 4/4"
    },
    {
      "when": {
        "up": "12",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.34
        },
        {
          "qty": 100,
          "unit": 0.69
        },
        {
          "qty": 250,
          "unit": 0.3
        },
        {
          "qty": 500,
          "unit": 0.17
        },
        {
          "qty": 1000,
          "unit": 0.1
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "12",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.12
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "12",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.34
        },
        {
          "qty": 100,
          "unit": 0.69
        },
        {
          "qty": 250,
          "unit": 0.3
        },
        {
          "qty": 500,
          "unit": 0.17
        },
        {
          "qty": 1000,
          "unit": 0.11
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "12",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.36
        },
        {
          "qty": 100,
          "unit": 0.71
        },
        {
          "qty": 250,
          "unit": 0.32
        },
        {
          "qty": 500,
          "unit": 0.19
        },
        {
          "qty": 1000,
          "unit": 0.12
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "12",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.36
        },
        {
          "qty": 100,
          "unit": 0.71
        },
        {
          "qty": 250,
          "unit": 0.32
        },
        {
          "qty": 500,
          "unit": 0.19
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "12",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.34
        },
        {
          "qty": 100,
          "unit": 0.69
        },
        {
          "qty": 250,
          "unit": 0.3
        },
        {
          "qty": 500,
          "unit": 0.17
        },
        {
          "qty": 1000,
          "unit": 0.1
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "12",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.36
        },
        {
          "qty": 100,
          "unit": 0.71
        },
        {
          "qty": 250,
          "unit": 0.32
        },
        {
          "qty": 500,
          "unit": 0.19
        },
        {
          "qty": 1000,
          "unit": 0.12
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "12",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.34
        },
        {
          "qty": 100,
          "unit": 0.69
        },
        {
          "qty": 250,
          "unit": 0.3
        },
        {
          "qty": 500,
          "unit": 0.17
        },
        {
          "qty": 1000,
          "unit": 0.11
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "12",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.36
        },
        {
          "qty": 100,
          "unit": 0.71
        },
        {
          "qty": 250,
          "unit": 0.32
        },
        {
          "qty": 500,
          "unit": 0.19
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "12",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.37
        },
        {
          "qty": 100,
          "unit": 0.72
        },
        {
          "qty": 250,
          "unit": 0.33
        },
        {
          "qty": 500,
          "unit": 0.2
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "12",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.34
        },
        {
          "qty": 100,
          "unit": 0.69
        },
        {
          "qty": 250,
          "unit": 0.3
        },
        {
          "qty": 500,
          "unit": 0.17
        },
        {
          "qty": 1000,
          "unit": 0.11
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "12",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.37
        },
        {
          "qty": 100,
          "unit": 0.72
        },
        {
          "qty": 250,
          "unit": 0.33
        },
        {
          "qty": 500,
          "unit": 0.2
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "12",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.11
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "12",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.37
        },
        {
          "qty": 100,
          "unit": 0.72
        },
        {
          "qty": 250,
          "unit": 0.33
        },
        {
          "qty": 500,
          "unit": 0.2
        },
        {
          "qty": 1000,
          "unit": 0.14
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "12",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.38
        },
        {
          "qty": 100,
          "unit": 0.73
        },
        {
          "qty": 250,
          "unit": 0.34
        },
        {
          "qty": 500,
          "unit": 0.21
        },
        {
          "qty": 1000,
          "unit": 0.14
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "12",
        "stock": "14pt-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.36
        },
        {
          "qty": 100,
          "unit": 0.71
        },
        {
          "qty": 250,
          "unit": 0.32
        },
        {
          "qty": 500,
          "unit": 0.19
        },
        {
          "qty": 1000,
          "unit": 0.12
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"14pt – 12x18\" 1/0"
    },
    {
      "when": {
        "up": "12",
        "stock": "14pt-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.39
        },
        {
          "qty": 100,
          "unit": 0.74
        },
        {
          "qty": 250,
          "unit": 0.35
        },
        {
          "qty": 500,
          "unit": 0.22
        },
        {
          "qty": 1000,
          "unit": 0.16
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"14pt – 12x18\" 1/1"
    },
    {
      "when": {
        "up": "12",
        "stock": "14pt-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.36
        },
        {
          "qty": 100,
          "unit": 0.71
        },
        {
          "qty": 250,
          "unit": 0.32
        },
        {
          "qty": 500,
          "unit": 0.19
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"14pt – 12x18\" 4/0"
    },
    {
      "when": {
        "up": "12",
        "stock": "14pt-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.4
        },
        {
          "qty": 100,
          "unit": 0.75
        },
        {
          "qty": 250,
          "unit": 0.36
        },
        {
          "qty": 500,
          "unit": 0.23
        },
        {
          "qty": 1000,
          "unit": 0.16
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"14pt – 12x18\" 4/1"
    },
    {
      "when": {
        "up": "12",
        "stock": "14pt-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.4
        },
        {
          "qty": 100,
          "unit": 0.75
        },
        {
          "qty": 250,
          "unit": 0.36
        },
        {
          "qty": 500,
          "unit": 0.23
        },
        {
          "qty": 1000,
          "unit": 0.17
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"14pt – 12x18\" 4/4"
    },
    {
      "when": {
        "up": "12",
        "stock": "16pt-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.36
        },
        {
          "qty": 100,
          "unit": 0.71
        },
        {
          "qty": 250,
          "unit": 0.32
        },
        {
          "qty": 500,
          "unit": 0.19
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"16pt – 12x18\" 1/0"
    },
    {
      "when": {
        "up": "12",
        "stock": "16pt-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.41
        },
        {
          "qty": 100,
          "unit": 0.76
        },
        {
          "qty": 250,
          "unit": 0.37
        },
        {
          "qty": 500,
          "unit": 0.24
        },
        {
          "qty": 1000,
          "unit": 0.18
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"16pt – 12x18\" 1/1"
    },
    {
      "when": {
        "up": "12",
        "stock": "16pt-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.37
        },
        {
          "qty": 100,
          "unit": 0.72
        },
        {
          "qty": 250,
          "unit": 0.33
        },
        {
          "qty": 500,
          "unit": 0.2
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"16pt – 12x18\" 4/0"
    },
    {
      "when": {
        "up": "12",
        "stock": "16pt-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.42
        },
        {
          "qty": 100,
          "unit": 0.77
        },
        {
          "qty": 250,
          "unit": 0.38
        },
        {
          "qty": 500,
          "unit": 0.25
        },
        {
          "qty": 1000,
          "unit": 0.18
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"16pt – 12x18\" 4/1"
    },
    {
      "when": {
        "up": "12",
        "stock": "16pt-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.42
        },
        {
          "qty": 100,
          "unit": 0.77
        },
        {
          "qty": 250,
          "unit": 0.38
        },
        {
          "qty": 500,
          "unit": 0.25
        },
        {
          "qty": 1000,
          "unit": 0.19
        }
      ],
      "source": "PRINTING/Bond Price Sheet 12-Up.docx: \"16pt – 12x18\" 4/4"
    },
    {
      "when": {
        "up": "2",
        "stock": "20-bond-8-5x11",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.46
        },
        {
          "qty": 100,
          "unit": 0.81
        },
        {
          "qty": 250,
          "unit": 0.42
        },
        {
          "qty": 500,
          "unit": 0.29
        },
        {
          "qty": 1000,
          "unit": 0.23
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"20# Bond 8.5x11\" 1/0"
    },
    {
      "when": {
        "up": "2",
        "stock": "20-bond-8-5x11",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.51
        },
        {
          "qty": 100,
          "unit": 0.86
        },
        {
          "qty": 250,
          "unit": 0.47
        },
        {
          "qty": 500,
          "unit": 0.34
        },
        {
          "qty": 1000,
          "unit": 0.28
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"20# Bond 8.5x11\" 1/1"
    },
    {
      "when": {
        "up": "2",
        "stock": "20-bond-8-5x11",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.49
        },
        {
          "qty": 100,
          "unit": 0.84
        },
        {
          "qty": 250,
          "unit": 0.45
        },
        {
          "qty": 500,
          "unit": 0.32
        },
        {
          "qty": 1000,
          "unit": 0.26
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"20# Bond 8.5x11\" 4/0"
    },
    {
      "when": {
        "up": "2",
        "stock": "20-bond-8-5x11",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.54
        },
        {
          "qty": 100,
          "unit": 0.89
        },
        {
          "qty": 250,
          "unit": 0.5
        },
        {
          "qty": 500,
          "unit": 0.37
        },
        {
          "qty": 1000,
          "unit": 0.31
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"20# Bond 8.5x11\" 4/1"
    },
    {
      "when": {
        "up": "2",
        "stock": "20-bond-8-5x11",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.57
        },
        {
          "qty": 100,
          "unit": 0.92
        },
        {
          "qty": 250,
          "unit": 0.53
        },
        {
          "qty": 500,
          "unit": 0.4
        },
        {
          "qty": 1000,
          "unit": 0.34
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"20# Bond 8.5x11\" 4/4"
    },
    {
      "when": {
        "up": "2",
        "stock": "20-bond-11x17",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.49
        },
        {
          "qty": 100,
          "unit": 0.84
        },
        {
          "qty": 250,
          "unit": 0.45
        },
        {
          "qty": 500,
          "unit": 0.32
        },
        {
          "qty": 1000,
          "unit": 0.25
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"20# Bond 11x17\" 1/0"
    },
    {
      "when": {
        "up": "2",
        "stock": "20-bond-11x17",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.56
        },
        {
          "qty": 100,
          "unit": 0.91
        },
        {
          "qty": 250,
          "unit": 0.52
        },
        {
          "qty": 500,
          "unit": 0.39
        },
        {
          "qty": 1000,
          "unit": 0.33
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"20# Bond 11x17\" 1/1"
    },
    {
      "when": {
        "up": "2",
        "stock": "20-bond-11x17",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.52
        },
        {
          "qty": 100,
          "unit": 0.87
        },
        {
          "qty": 250,
          "unit": 0.48
        },
        {
          "qty": 500,
          "unit": 0.35
        },
        {
          "qty": 1000,
          "unit": 0.28
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"20# Bond 11x17\" 4/0"
    },
    {
      "when": {
        "up": "2",
        "stock": "20-bond-11x17",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.59
        },
        {
          "qty": 100,
          "unit": 0.94
        },
        {
          "qty": 250,
          "unit": 0.55
        },
        {
          "qty": 500,
          "unit": 0.42
        },
        {
          "qty": 1000,
          "unit": 0.36
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"20# Bond 11x17\" 4/1"
    },
    {
      "when": {
        "up": "2",
        "stock": "20-bond-11x17",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.62
        },
        {
          "qty": 100,
          "unit": 0.97
        },
        {
          "qty": 250,
          "unit": 0.58
        },
        {
          "qty": 500,
          "unit": 0.45
        },
        {
          "qty": 1000,
          "unit": 0.39
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"20# Bond 11x17\" 4/4"
    },
    {
      "when": {
        "up": "2",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.51
        },
        {
          "qty": 100,
          "unit": 0.86
        },
        {
          "qty": 250,
          "unit": 0.47
        },
        {
          "qty": 500,
          "unit": 0.34
        },
        {
          "qty": 1000,
          "unit": 0.28
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "2",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.61
        },
        {
          "qty": 100,
          "unit": 0.96
        },
        {
          "qty": 250,
          "unit": 0.57
        },
        {
          "qty": 500,
          "unit": 0.44
        },
        {
          "qty": 1000,
          "unit": 0.38
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "2",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.54
        },
        {
          "qty": 100,
          "unit": 0.89
        },
        {
          "qty": 250,
          "unit": 0.5
        },
        {
          "qty": 500,
          "unit": 0.37
        },
        {
          "qty": 1000,
          "unit": 0.31
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "2",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.64
        },
        {
          "qty": 100,
          "unit": 0.99
        },
        {
          "qty": 250,
          "unit": 0.6
        },
        {
          "qty": 500,
          "unit": 0.47
        },
        {
          "qty": 1000,
          "unit": 0.41
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "2",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.67
        },
        {
          "qty": 100,
          "unit": 1.02
        },
        {
          "qty": 250,
          "unit": 0.63
        },
        {
          "qty": 500,
          "unit": 0.5
        },
        {
          "qty": 1000,
          "unit": 0.44
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "2",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.53
        },
        {
          "qty": 100,
          "unit": 0.88
        },
        {
          "qty": 250,
          "unit": 0.49
        },
        {
          "qty": 500,
          "unit": 0.36
        },
        {
          "qty": 1000,
          "unit": 0.29
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "2",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.64
        },
        {
          "qty": 100,
          "unit": 0.99
        },
        {
          "qty": 250,
          "unit": 0.6
        },
        {
          "qty": 500,
          "unit": 0.47
        },
        {
          "qty": 1000,
          "unit": 0.41
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "2",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.56
        },
        {
          "qty": 100,
          "unit": 0.91
        },
        {
          "qty": 250,
          "unit": 0.52
        },
        {
          "qty": 500,
          "unit": 0.39
        },
        {
          "qty": 1000,
          "unit": 0.32
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "2",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.67
        },
        {
          "qty": 100,
          "unit": 1.02
        },
        {
          "qty": 250,
          "unit": 0.63
        },
        {
          "qty": 500,
          "unit": 0.5
        },
        {
          "qty": 1000,
          "unit": 0.44
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "2",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.7
        },
        {
          "qty": 100,
          "unit": 1.05
        },
        {
          "qty": 250,
          "unit": 0.66
        },
        {
          "qty": 500,
          "unit": 0.53
        },
        {
          "qty": 1000,
          "unit": 0.47
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "2",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.56
        },
        {
          "qty": 100,
          "unit": 0.91
        },
        {
          "qty": 250,
          "unit": 0.52
        },
        {
          "qty": 500,
          "unit": 0.39
        },
        {
          "qty": 1000,
          "unit": 0.33
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "2",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.71
        },
        {
          "qty": 100,
          "unit": 1.06
        },
        {
          "qty": 250,
          "unit": 0.67
        },
        {
          "qty": 500,
          "unit": 0.54
        },
        {
          "qty": 1000,
          "unit": 0.48
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "2",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.59
        },
        {
          "qty": 100,
          "unit": 0.94
        },
        {
          "qty": 250,
          "unit": 0.55
        },
        {
          "qty": 500,
          "unit": 0.42
        },
        {
          "qty": 1000,
          "unit": 0.36
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "2",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.74
        },
        {
          "qty": 100,
          "unit": 1.09
        },
        {
          "qty": 250,
          "unit": 0.7
        },
        {
          "qty": 500,
          "unit": 0.57
        },
        {
          "qty": 1000,
          "unit": 0.51
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "2",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.77
        },
        {
          "qty": 100,
          "unit": 1.12
        },
        {
          "qty": 250,
          "unit": 0.73
        },
        {
          "qty": 500,
          "unit": 0.6
        },
        {
          "qty": 1000,
          "unit": 0.54
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "2",
        "stock": "14pt-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.64
        },
        {
          "qty": 100,
          "unit": 0.99
        },
        {
          "qty": 250,
          "unit": 0.6
        },
        {
          "qty": 500,
          "unit": 0.47
        },
        {
          "qty": 1000,
          "unit": 0.46
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"14pt – 12x18\" 1/0"
    },
    {
      "when": {
        "up": "2",
        "stock": "14pt-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.86
        },
        {
          "qty": 100,
          "unit": 1.21
        },
        {
          "qty": 250,
          "unit": 0.82
        },
        {
          "qty": 500,
          "unit": 0.69
        },
        {
          "qty": 1000,
          "unit": 0.63
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"14pt – 12x18\" 1/1"
    },
    {
      "when": {
        "up": "2",
        "stock": "14pt-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.67
        },
        {
          "qty": 100,
          "unit": 1.02
        },
        {
          "qty": 250,
          "unit": 0.63
        },
        {
          "qty": 500,
          "unit": 0.5
        },
        {
          "qty": 1000,
          "unit": 0.43
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"14pt – 12x18\" 4/0"
    },
    {
      "when": {
        "up": "2",
        "stock": "14pt-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.89
        },
        {
          "qty": 100,
          "unit": 1.24
        },
        {
          "qty": 250,
          "unit": 0.85
        },
        {
          "qty": 500,
          "unit": 0.72
        },
        {
          "qty": 1000,
          "unit": 0.66
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"14pt – 12x18\" 4/1"
    },
    {
      "when": {
        "up": "2",
        "stock": "14pt-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.92
        },
        {
          "qty": 100,
          "unit": 1.27
        },
        {
          "qty": 250,
          "unit": 0.88
        },
        {
          "qty": 500,
          "unit": 0.75
        },
        {
          "qty": 1000,
          "unit": 0.69
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"14pt – 12x18\" 4/4"
    },
    {
      "when": {
        "up": "2",
        "stock": "16pt-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.69
        },
        {
          "qty": 100,
          "unit": 1.04
        },
        {
          "qty": 250,
          "unit": 0.65
        },
        {
          "qty": 500,
          "unit": 0.52
        },
        {
          "qty": 1000,
          "unit": 0.45
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"16pt – 12x18\" 1/0"
    },
    {
      "when": {
        "up": "2",
        "stock": "16pt-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.96
        },
        {
          "qty": 100,
          "unit": 1.31
        },
        {
          "qty": 250,
          "unit": 0.92
        },
        {
          "qty": 500,
          "unit": 0.79
        },
        {
          "qty": 1000,
          "unit": 0.73
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"16pt – 12x18\" 1/1"
    },
    {
      "when": {
        "up": "2",
        "stock": "16pt-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.72
        },
        {
          "qty": 100,
          "unit": 1.07
        },
        {
          "qty": 250,
          "unit": 0.68
        },
        {
          "qty": 500,
          "unit": 0.55
        },
        {
          "qty": 1000,
          "unit": 0.48
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"16pt – 12x18\" 4/0"
    },
    {
      "when": {
        "up": "2",
        "stock": "16pt-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.99
        },
        {
          "qty": 100,
          "unit": 1.34
        },
        {
          "qty": 250,
          "unit": 0.99
        },
        {
          "qty": 500,
          "unit": 0.82
        },
        {
          "qty": 1000,
          "unit": 0.76
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"16pt – 12x18\" 4/1"
    },
    {
      "when": {
        "up": "2",
        "stock": "16pt-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 2.02
        },
        {
          "qty": 100,
          "unit": 1.37
        },
        {
          "qty": 250,
          "unit": 0.98
        },
        {
          "qty": 500,
          "unit": 0.85
        },
        {
          "qty": 1000,
          "unit": 0.79
        }
      ],
      "source": "PRINTING/Bond Price Sheet 2-Up.docx: \"16pt – 12x18\" 4/4"
    },
    {
      "when": {
        "up": "3",
        "stock": "20-bond-8-5x11",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.41
        },
        {
          "qty": 100,
          "unit": 0.76
        },
        {
          "qty": 250,
          "unit": 0.37
        },
        {
          "qty": 500,
          "unit": 0.24
        },
        {
          "qty": 1000,
          "unit": 0.17
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"20# Bond 8.5x11\" 1/0"
    },
    {
      "when": {
        "up": "3",
        "stock": "20-bond-8-5x11",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.44
        },
        {
          "qty": 100,
          "unit": 0.79
        },
        {
          "qty": 250,
          "unit": 0.4
        },
        {
          "qty": 500,
          "unit": 0.27
        },
        {
          "qty": 1000,
          "unit": 0.21
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"20# Bond 8.5x11\" 1/1"
    },
    {
      "when": {
        "up": "3",
        "stock": "20-bond-8-5x11",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.43
        },
        {
          "qty": 100,
          "unit": 0.78
        },
        {
          "qty": 250,
          "unit": 0.39
        },
        {
          "qty": 500,
          "unit": 0.26
        },
        {
          "qty": 1000,
          "unit": 0.19
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"20# Bond 8.5x11\" 4/0"
    },
    {
      "when": {
        "up": "3",
        "stock": "20-bond-8-5x11",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.46
        },
        {
          "qty": 100,
          "unit": 0.81
        },
        {
          "qty": 250,
          "unit": 0.42
        },
        {
          "qty": 500,
          "unit": 0.29
        },
        {
          "qty": 1000,
          "unit": 0.23
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"20# Bond 8.5x11\" 4/1"
    },
    {
      "when": {
        "up": "3",
        "stock": "20-bond-8-5x11",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.48
        },
        {
          "qty": 100,
          "unit": 0.83
        },
        {
          "qty": 250,
          "unit": 0.44
        },
        {
          "qty": 500,
          "unit": 0.31
        },
        {
          "qty": 1000,
          "unit": 0.25
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"20# Bond 8.5x11\" 4/4"
    },
    {
      "when": {
        "up": "3",
        "stock": "20-bond-11x17",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.42
        },
        {
          "qty": 100,
          "unit": 0.77
        },
        {
          "qty": 250,
          "unit": 0.38
        },
        {
          "qty": 500,
          "unit": 0.25
        },
        {
          "qty": 1000,
          "unit": 0.19
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"20# Bond 11x17\" 1/0"
    },
    {
      "when": {
        "up": "3",
        "stock": "20-bond-11x17",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.47
        },
        {
          "qty": 100,
          "unit": 0.82
        },
        {
          "qty": 250,
          "unit": 0.43
        },
        {
          "qty": 500,
          "unit": 0.3
        },
        {
          "qty": 1000,
          "unit": 0.24
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"20# Bond 11x17\" 1/1"
    },
    {
      "when": {
        "up": "3",
        "stock": "20-bond-11x17",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.44
        },
        {
          "qty": 100,
          "unit": 0.79
        },
        {
          "qty": 250,
          "unit": 0.4
        },
        {
          "qty": 500,
          "unit": 0.27
        },
        {
          "qty": 1000,
          "unit": 0.21
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"20# Bond 11x17\" 4/0"
    },
    {
      "when": {
        "up": "3",
        "stock": "20-bond-11x17",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.49
        },
        {
          "qty": 100,
          "unit": 0.84
        },
        {
          "qty": 250,
          "unit": 0.45
        },
        {
          "qty": 500,
          "unit": 0.32
        },
        {
          "qty": 1000,
          "unit": 0.26
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"20# Bond 11x17\" 4/1"
    },
    {
      "when": {
        "up": "3",
        "stock": "20-bond-11x17",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.51
        },
        {
          "qty": 100,
          "unit": 0.86
        },
        {
          "qty": 250,
          "unit": 0.47
        },
        {
          "qty": 500,
          "unit": 0.34
        },
        {
          "qty": 1000,
          "unit": 0.28
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"20# Bond 11x17\" 4/4"
    },
    {
      "when": {
        "up": "3",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.44
        },
        {
          "qty": 100,
          "unit": 0.79
        },
        {
          "qty": 250,
          "unit": 0.4
        },
        {
          "qty": 500,
          "unit": 0.27
        },
        {
          "qty": 1000,
          "unit": 0.21
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "3",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.51
        },
        {
          "qty": 100,
          "unit": 0.86
        },
        {
          "qty": 250,
          "unit": 0.47
        },
        {
          "qty": 500,
          "unit": 0.34
        },
        {
          "qty": 1000,
          "unit": 0.27
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "3",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.46
        },
        {
          "qty": 100,
          "unit": 0.81
        },
        {
          "qty": 250,
          "unit": 0.42
        },
        {
          "qty": 500,
          "unit": 0.29
        },
        {
          "qty": 1000,
          "unit": 0.23
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "3",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.53
        },
        {
          "qty": 100,
          "unit": 0.88
        },
        {
          "qty": 250,
          "unit": 0.49
        },
        {
          "qty": 500,
          "unit": 0.36
        },
        {
          "qty": 1000,
          "unit": 0.29
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "3",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.55
        },
        {
          "qty": 100,
          "unit": 0.9
        },
        {
          "qty": 250,
          "unit": 0.51
        },
        {
          "qty": 500,
          "unit": 0.38
        },
        {
          "qty": 1000,
          "unit": 0.31
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "3",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.45
        },
        {
          "qty": 100,
          "unit": 0.8
        },
        {
          "qty": 250,
          "unit": 0.41
        },
        {
          "qty": 500,
          "unit": 0.28
        },
        {
          "qty": 1000,
          "unit": 0.22
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "3",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.47
        },
        {
          "qty": 100,
          "unit": 0.82
        },
        {
          "qty": 250,
          "unit": 0.43
        },
        {
          "qty": 500,
          "unit": 0.3
        },
        {
          "qty": 1000,
          "unit": 0.24
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "3",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.47
        },
        {
          "qty": 100,
          "unit": 0.82
        },
        {
          "qty": 250,
          "unit": 0.43
        },
        {
          "qty": 500,
          "unit": 0.3
        },
        {
          "qty": 1000,
          "unit": 0.24
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "3",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.55
        },
        {
          "qty": 100,
          "unit": 0.9
        },
        {
          "qty": 250,
          "unit": 0.51
        },
        {
          "qty": 500,
          "unit": 0.38
        },
        {
          "qty": 1000,
          "unit": 0.31
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "3",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.57
        },
        {
          "qty": 100,
          "unit": 0.92
        },
        {
          "qty": 250,
          "unit": 0.53
        },
        {
          "qty": 500,
          "unit": 0.4
        },
        {
          "qty": 1000,
          "unit": 0.33
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "3",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.47
        },
        {
          "qty": 100,
          "unit": 0.82
        },
        {
          "qty": 250,
          "unit": 0.43
        },
        {
          "qty": 500,
          "unit": 0.3
        },
        {
          "qty": 1000,
          "unit": 0.24
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "3",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.57
        },
        {
          "qty": 100,
          "unit": 0.92
        },
        {
          "qty": 250,
          "unit": 0.53
        },
        {
          "qty": 500,
          "unit": 0.4
        },
        {
          "qty": 1000,
          "unit": 0.34
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "3",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.49
        },
        {
          "qty": 100,
          "unit": 0.84
        },
        {
          "qty": 250,
          "unit": 0.45
        },
        {
          "qty": 500,
          "unit": 0.32
        },
        {
          "qty": 1000,
          "unit": 0.26
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "3",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.59
        },
        {
          "qty": 100,
          "unit": 0.94
        },
        {
          "qty": 250,
          "unit": 0.55
        },
        {
          "qty": 500,
          "unit": 0.42
        },
        {
          "qty": 1000,
          "unit": 0.36
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "3",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.61
        },
        {
          "qty": 100,
          "unit": 0.96
        },
        {
          "qty": 250,
          "unit": 0.57
        },
        {
          "qty": 500,
          "unit": 0.44
        },
        {
          "qty": 1000,
          "unit": 0.38
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "3",
        "stock": "14pt-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.52
        },
        {
          "qty": 100,
          "unit": 0.87
        },
        {
          "qty": 250,
          "unit": 0.48
        },
        {
          "qty": 500,
          "unit": 0.35
        },
        {
          "qty": 1000,
          "unit": 0.29
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"14pt – 12x18\" 1/0"
    },
    {
      "when": {
        "up": "3",
        "stock": "14pt-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.67
        },
        {
          "qty": 100,
          "unit": 1.02
        },
        {
          "qty": 250,
          "unit": 0.63
        },
        {
          "qty": 500,
          "unit": 0.5
        },
        {
          "qty": 1000,
          "unit": 0.44
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"14pt – 12x18\" 1/1"
    },
    {
      "when": {
        "up": "3",
        "stock": "14pt-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.54
        },
        {
          "qty": 100,
          "unit": 0.89
        },
        {
          "qty": 250,
          "unit": 0.5
        },
        {
          "qty": 500,
          "unit": 0.37
        },
        {
          "qty": 1000,
          "unit": 0.31
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"14pt – 12x18\" 4/0"
    },
    {
      "when": {
        "up": "3",
        "stock": "14pt-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.69
        },
        {
          "qty": 100,
          "unit": 1.04
        },
        {
          "qty": 250,
          "unit": 0.65
        },
        {
          "qty": 500,
          "unit": 0.52
        },
        {
          "qty": 1000,
          "unit": 0.45
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"14pt – 12x18\" 4/1"
    },
    {
      "when": {
        "up": "3",
        "stock": "14pt-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.71
        },
        {
          "qty": 100,
          "unit": 1.06
        },
        {
          "qty": 250,
          "unit": 0.67
        },
        {
          "qty": 500,
          "unit": 0.54
        },
        {
          "qty": 1000,
          "unit": 0.48
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"14pt – 12x18\" 4/4"
    },
    {
      "when": {
        "up": "3",
        "stock": "16pt-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.56
        },
        {
          "qty": 100,
          "unit": 0.91
        },
        {
          "qty": 250,
          "unit": 0.52
        },
        {
          "qty": 500,
          "unit": 0.39
        },
        {
          "qty": 1000,
          "unit": 0.32
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"16pt – 12x18\" 1/0"
    },
    {
      "when": {
        "up": "3",
        "stock": "16pt-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.74
        },
        {
          "qty": 100,
          "unit": 1.09
        },
        {
          "qty": 250,
          "unit": 0.7
        },
        {
          "qty": 500,
          "unit": 0.57
        },
        {
          "qty": 1000,
          "unit": 0.51
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"16pt – 12x18\" 1/1"
    },
    {
      "when": {
        "up": "3",
        "stock": "16pt-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.58
        },
        {
          "qty": 100,
          "unit": 0.93
        },
        {
          "qty": 250,
          "unit": 0.54
        },
        {
          "qty": 500,
          "unit": 0.41
        },
        {
          "qty": 1000,
          "unit": 0.34
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"16pt – 12x18\" 4/0"
    },
    {
      "when": {
        "up": "3",
        "stock": "16pt-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.76
        },
        {
          "qty": 100,
          "unit": 1.11
        },
        {
          "qty": 250,
          "unit": 0.72
        },
        {
          "qty": 500,
          "unit": 0.59
        },
        {
          "qty": 1000,
          "unit": 0.53
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"16pt – 12x18\" 4/1"
    },
    {
      "when": {
        "up": "3",
        "stock": "16pt-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.78
        },
        {
          "qty": 100,
          "unit": 1.13
        },
        {
          "qty": 250,
          "unit": 0.74
        },
        {
          "qty": 500,
          "unit": 0.61
        },
        {
          "qty": 1000,
          "unit": 0.55
        }
      ],
      "source": "PRINTING/Bond Price Sheet 3-Up.docx: \"16pt – 12x18\" 4/4"
    },
    {
      "when": {
        "up": "4",
        "stock": "20-bond-8-5x11",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.38
        },
        {
          "qty": 100,
          "unit": 0.73
        },
        {
          "qty": 250,
          "unit": 0.34
        },
        {
          "qty": 500,
          "unit": 0.21
        },
        {
          "qty": 1000,
          "unit": 0.15
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"20# Bond 8.5x11\" 1/0"
    },
    {
      "when": {
        "up": "4",
        "stock": "20-bond-8-5x11",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.41
        },
        {
          "qty": 100,
          "unit": 0.76
        },
        {
          "qty": 250,
          "unit": 0.37
        },
        {
          "qty": 500,
          "unit": 0.24
        },
        {
          "qty": 1000,
          "unit": 0.17
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"20# Bond 8.5x11\" 1/1"
    },
    {
      "when": {
        "up": "4",
        "stock": "20-bond-8-5x11",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.4
        },
        {
          "qty": 100,
          "unit": 0.75
        },
        {
          "qty": 250,
          "unit": 0.36
        },
        {
          "qty": 500,
          "unit": 0.23
        },
        {
          "qty": 1000,
          "unit": 0.16
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"20# Bond 8.5x11\" 4/0"
    },
    {
      "when": {
        "up": "4",
        "stock": "20-bond-8-5x11",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.42
        },
        {
          "qty": 100,
          "unit": 0.77
        },
        {
          "qty": 250,
          "unit": 0.38
        },
        {
          "qty": 500,
          "unit": 0.25
        },
        {
          "qty": 1000,
          "unit": 0.19
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"20# Bond 8.5x11\" 4/1"
    },
    {
      "when": {
        "up": "4",
        "stock": "20-bond-8-5x11",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.44
        },
        {
          "qty": 100,
          "unit": 0.79
        },
        {
          "qty": 250,
          "unit": 0.4
        },
        {
          "qty": 500,
          "unit": 0.27
        },
        {
          "qty": 1000,
          "unit": 0.2
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"20# Bond 8.5x11\" 4/4"
    },
    {
      "when": {
        "up": "4",
        "stock": "20-bond-11x17",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.39
        },
        {
          "qty": 100,
          "unit": 0.74
        },
        {
          "qty": 250,
          "unit": 0.35
        },
        {
          "qty": 500,
          "unit": 0.22
        },
        {
          "qty": 1000,
          "unit": 0.16
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"20# Bond 11x17\" 1/0"
    },
    {
      "when": {
        "up": "4",
        "stock": "20-bond-11x17",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.43
        },
        {
          "qty": 100,
          "unit": 0.78
        },
        {
          "qty": 250,
          "unit": 0.39
        },
        {
          "qty": 500,
          "unit": 0.26
        },
        {
          "qty": 1000,
          "unit": 0.2
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"20# Bond 11x17\" 1/1"
    },
    {
      "when": {
        "up": "4",
        "stock": "20-bond-11x17",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.41
        },
        {
          "qty": 100,
          "unit": 0.76
        },
        {
          "qty": 250,
          "unit": 0.37
        },
        {
          "qty": 500,
          "unit": 0.24
        },
        {
          "qty": 1000,
          "unit": 0.17
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"20# Bond 11x17\" 4/0"
    },
    {
      "when": {
        "up": "4",
        "stock": "20-bond-11x17",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.45
        },
        {
          "qty": 100,
          "unit": 0.8
        },
        {
          "qty": 250,
          "unit": 0.41
        },
        {
          "qty": 500,
          "unit": 0.28
        },
        {
          "qty": 1000,
          "unit": 0.21
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"20# Bond 11x17\" 4/1"
    },
    {
      "when": {
        "up": "4",
        "stock": "20-bond-11x17",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.46
        },
        {
          "qty": 100,
          "unit": 0.81
        },
        {
          "qty": 250,
          "unit": 0.42
        },
        {
          "qty": 500,
          "unit": 0.29
        },
        {
          "qty": 1000,
          "unit": 0.23
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"20# Bond 11x17\" 4/4"
    },
    {
      "when": {
        "up": "4",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.41
        },
        {
          "qty": 100,
          "unit": 0.76
        },
        {
          "qty": 250,
          "unit": 0.37
        },
        {
          "qty": 500,
          "unit": 0.24
        },
        {
          "qty": 1000,
          "unit": 0.17
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "4",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.46
        },
        {
          "qty": 100,
          "unit": 0.81
        },
        {
          "qty": 250,
          "unit": 0.42
        },
        {
          "qty": 500,
          "unit": 0.29
        },
        {
          "qty": 1000,
          "unit": 0.22
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "4",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.42
        },
        {
          "qty": 100,
          "unit": 0.77
        },
        {
          "qty": 250,
          "unit": 0.38
        },
        {
          "qty": 500,
          "unit": 0.25
        },
        {
          "qty": 1000,
          "unit": 0.19
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "4",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.47
        },
        {
          "qty": 100,
          "unit": 0.82
        },
        {
          "qty": 250,
          "unit": 0.43
        },
        {
          "qty": 500,
          "unit": 0.3
        },
        {
          "qty": 1000,
          "unit": 0.24
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "4",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.49
        },
        {
          "qty": 100,
          "unit": 0.84
        },
        {
          "qty": 250,
          "unit": 0.45
        },
        {
          "qty": 500,
          "unit": 0.32
        },
        {
          "qty": 1000,
          "unit": 0.25
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "4",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.41
        },
        {
          "qty": 100,
          "unit": 0.76
        },
        {
          "qty": 250,
          "unit": 0.37
        },
        {
          "qty": 500,
          "unit": 0.24
        },
        {
          "qty": 1000,
          "unit": 0.18
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "4",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.47
        },
        {
          "qty": 100,
          "unit": 0.82
        },
        {
          "qty": 250,
          "unit": 0.43
        },
        {
          "qty": 500,
          "unit": 0.3
        },
        {
          "qty": 1000,
          "unit": 0.24
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "4",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.43
        },
        {
          "qty": 100,
          "unit": 0.78
        },
        {
          "qty": 250,
          "unit": 0.39
        },
        {
          "qty": 500,
          "unit": 0.26
        },
        {
          "qty": 1000,
          "unit": 0.19
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "4",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.49
        },
        {
          "qty": 100,
          "unit": 0.84
        },
        {
          "qty": 250,
          "unit": 0.45
        },
        {
          "qty": 500,
          "unit": 0.32
        },
        {
          "qty": 1000,
          "unit": 0.25
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "4",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.5
        },
        {
          "qty": 100,
          "unit": 0.85
        },
        {
          "qty": 250,
          "unit": 0.46
        },
        {
          "qty": 500,
          "unit": 0.33
        },
        {
          "qty": 1000,
          "unit": 0.27
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "4",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.43
        },
        {
          "qty": 100,
          "unit": 0.78
        },
        {
          "qty": 250,
          "unit": 0.39
        },
        {
          "qty": 500,
          "unit": 0.26
        },
        {
          "qty": 1000,
          "unit": 0.2
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "4",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.51
        },
        {
          "qty": 100,
          "unit": 0.86
        },
        {
          "qty": 250,
          "unit": 0.47
        },
        {
          "qty": 500,
          "unit": 0.34
        },
        {
          "qty": 1000,
          "unit": 0.27
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "4",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.45
        },
        {
          "qty": 100,
          "unit": 0.8
        },
        {
          "qty": 250,
          "unit": 0.41
        },
        {
          "qty": 500,
          "unit": 0.28
        },
        {
          "qty": 1000,
          "unit": 0.21
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "4",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.52
        },
        {
          "qty": 100,
          "unit": 0.87
        },
        {
          "qty": 250,
          "unit": 0.48
        },
        {
          "qty": 500,
          "unit": 0.35
        },
        {
          "qty": 1000,
          "unit": 0.29
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "4",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.54
        },
        {
          "qty": 100,
          "unit": 0.89
        },
        {
          "qty": 250,
          "unit": 0.5
        },
        {
          "qty": 500,
          "unit": 0.37
        },
        {
          "qty": 1000,
          "unit": 0.3
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "4",
        "stock": "14pt-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.47
        },
        {
          "qty": 100,
          "unit": 0.82
        },
        {
          "qty": 250,
          "unit": 0.43
        },
        {
          "qty": 500,
          "unit": 0.3
        },
        {
          "qty": 1000,
          "unit": 0.23
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"14pt – 12x18\" 1/0"
    },
    {
      "when": {
        "up": "4",
        "stock": "14pt-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.58
        },
        {
          "qty": 100,
          "unit": 0.93
        },
        {
          "qty": 250,
          "unit": 0.54
        },
        {
          "qty": 500,
          "unit": 0.41
        },
        {
          "qty": 1000,
          "unit": 0.35
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"14pt – 12x18\" 1/1"
    },
    {
      "when": {
        "up": "4",
        "stock": "14pt-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.48
        },
        {
          "qty": 100,
          "unit": 0.83
        },
        {
          "qty": 250,
          "unit": 0.44
        },
        {
          "qty": 500,
          "unit": 0.31
        },
        {
          "qty": 1000,
          "unit": 0.25
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"14pt – 12x18\" 4/0"
    },
    {
      "when": {
        "up": "4",
        "stock": "14pt-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.6
        },
        {
          "qty": 100,
          "unit": 0.95
        },
        {
          "qty": 250,
          "unit": 0.56
        },
        {
          "qty": 500,
          "unit": 0.43
        },
        {
          "qty": 1000,
          "unit": 0.36
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"14pt – 12x18\" 4/1"
    },
    {
      "when": {
        "up": "4",
        "stock": "14pt-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.61
        },
        {
          "qty": 100,
          "unit": 0.96
        },
        {
          "qty": 250,
          "unit": 0.57
        },
        {
          "qty": 500,
          "unit": 0.44
        },
        {
          "qty": 1000,
          "unit": 0.38
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"14pt – 12x18\" 4/4"
    },
    {
      "when": {
        "up": "4",
        "stock": "16pt-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.49
        },
        {
          "qty": 100,
          "unit": 0.84
        },
        {
          "qty": 250,
          "unit": 0.45
        },
        {
          "qty": 500,
          "unit": 0.32
        },
        {
          "qty": 1000,
          "unit": 0.26
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"16pt – 12x18\" 1/0"
    },
    {
      "when": {
        "up": "4",
        "stock": "16pt-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.63
        },
        {
          "qty": 100,
          "unit": 0.98
        },
        {
          "qty": 250,
          "unit": 0.59
        },
        {
          "qty": 500,
          "unit": 0.46
        },
        {
          "qty": 1000,
          "unit": 0.4
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"16pt – 12x18\" 1/1"
    },
    {
      "when": {
        "up": "4",
        "stock": "16pt-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.51
        },
        {
          "qty": 100,
          "unit": 0.86
        },
        {
          "qty": 250,
          "unit": 0.47
        },
        {
          "qty": 500,
          "unit": 0.34
        },
        {
          "qty": 1000,
          "unit": 0.27
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"16pt – 12x18\" 4/0"
    },
    {
      "when": {
        "up": "4",
        "stock": "16pt-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.65
        },
        {
          "qty": 100,
          "unit": 1
        },
        {
          "qty": 250,
          "unit": 0.61
        },
        {
          "qty": 500,
          "unit": 0.48
        },
        {
          "qty": 1000,
          "unit": 0.41
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"16pt – 12x18\" 4/1"
    },
    {
      "when": {
        "up": "4",
        "stock": "16pt-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.66
        },
        {
          "qty": 100,
          "unit": 1.01
        },
        {
          "qty": 250,
          "unit": 0.62
        },
        {
          "qty": 500,
          "unit": 0.49
        },
        {
          "qty": 1000,
          "unit": 0.43
        }
      ],
      "source": "PRINTING/Bond Price Sheet 4-Up.docx: \"16pt – 12x18\" 4/4"
    },
    {
      "when": {
        "up": "8",
        "stock": "20-bond-8-5x11",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.34
        },
        {
          "qty": 100,
          "unit": 0.69
        },
        {
          "qty": 250,
          "unit": 0.3
        },
        {
          "qty": 500,
          "unit": 0.17
        },
        {
          "qty": 1000,
          "unit": 0.11
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"20# Bond 8.5x11\" 1/0"
    },
    {
      "when": {
        "up": "8",
        "stock": "20-bond-8-5x11",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.12
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"20# Bond 8.5x11\" 1/1"
    },
    {
      "when": {
        "up": "8",
        "stock": "20-bond-8-5x11",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.11
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"20# Bond 8.5x11\" 4/0"
    },
    {
      "when": {
        "up": "8",
        "stock": "20-bond-8-5x11",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.36
        },
        {
          "qty": 100,
          "unit": 0.71
        },
        {
          "qty": 250,
          "unit": 0.32
        },
        {
          "qty": 500,
          "unit": 0.19
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"20# Bond 8.5x11\" 4/1"
    },
    {
      "when": {
        "up": "8",
        "stock": "20-bond-8-5x11",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.37
        },
        {
          "qty": 100,
          "unit": 0.72
        },
        {
          "qty": 250,
          "unit": 0.33
        },
        {
          "qty": 500,
          "unit": 0.2
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"20# Bond 8.5x11\" 4/4"
    },
    {
      "when": {
        "up": "8",
        "stock": "20-bond-11x17",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.11
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"20# Bond 11x17\" 1/0"
    },
    {
      "when": {
        "up": "8",
        "stock": "20-bond-11x17",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.37
        },
        {
          "qty": 100,
          "unit": 0.72
        },
        {
          "qty": 250,
          "unit": 0.33
        },
        {
          "qty": 500,
          "unit": 0.2
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"20# Bond 11x17\" 1/1"
    },
    {
      "when": {
        "up": "8",
        "stock": "20-bond-11x17",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.12
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"20# Bond 11x17\" 4/0"
    },
    {
      "when": {
        "up": "8",
        "stock": "20-bond-11x17",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.37
        },
        {
          "qty": 100,
          "unit": 0.72
        },
        {
          "qty": 250,
          "unit": 0.33
        },
        {
          "qty": 500,
          "unit": 0.2
        },
        {
          "qty": 1000,
          "unit": 0.14
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"20# Bond 11x17\" 4/1"
    },
    {
      "when": {
        "up": "8",
        "stock": "20-bond-11x17",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.38
        },
        {
          "qty": 100,
          "unit": 0.73
        },
        {
          "qty": 250,
          "unit": 0.34
        },
        {
          "qty": 500,
          "unit": 0.21
        },
        {
          "qty": 1000,
          "unit": 0.15
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"20# Bond 11x17\" 4/4"
    },
    {
      "when": {
        "up": "8",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.35
        },
        {
          "qty": 100,
          "unit": 0.7
        },
        {
          "qty": 250,
          "unit": 0.31
        },
        {
          "qty": 500,
          "unit": 0.18
        },
        {
          "qty": 1000,
          "unit": 0.12
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "8",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.38
        },
        {
          "qty": 100,
          "unit": 0.73
        },
        {
          "qty": 250,
          "unit": 0.34
        },
        {
          "qty": 500,
          "unit": 0.21
        },
        {
          "qty": 1000,
          "unit": 0.14
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "8",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.36
        },
        {
          "qty": 100,
          "unit": 0.71
        },
        {
          "qty": 250,
          "unit": 0.32
        },
        {
          "qty": 500,
          "unit": 0.19
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "8",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.39
        },
        {
          "qty": 100,
          "unit": 0.74
        },
        {
          "qty": 250,
          "unit": 0.35
        },
        {
          "qty": 500,
          "unit": 0.22
        },
        {
          "qty": 1000,
          "unit": 0.15
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "8",
        "stock": "60-bond-11x17-80-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.39
        },
        {
          "qty": 100,
          "unit": 0.74
        },
        {
          "qty": 250,
          "unit": 0.35
        },
        {
          "qty": 500,
          "unit": 0.22
        },
        {
          "qty": 1000,
          "unit": 0.16
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"60# Bond 11x17 & 80# Cover or Text – Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "8",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.36
        },
        {
          "qty": 100,
          "unit": 0.71
        },
        {
          "qty": 250,
          "unit": 0.32
        },
        {
          "qty": 500,
          "unit": 0.19
        },
        {
          "qty": 1000,
          "unit": 0.12
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "8",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.39
        },
        {
          "qty": 100,
          "unit": 0.74
        },
        {
          "qty": 250,
          "unit": 0.35
        },
        {
          "qty": 500,
          "unit": 0.22
        },
        {
          "qty": 1000,
          "unit": 0.15
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "8",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.36
        },
        {
          "qty": 100,
          "unit": 0.71
        },
        {
          "qty": 250,
          "unit": 0.32
        },
        {
          "qty": 500,
          "unit": 0.19
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "8",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.39
        },
        {
          "qty": 100,
          "unit": 0.74
        },
        {
          "qty": 250,
          "unit": 0.35
        },
        {
          "qty": 500,
          "unit": 0.22
        },
        {
          "qty": 1000,
          "unit": 0.16
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "8",
        "stock": "100-cover-or-text-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.4
        },
        {
          "qty": 100,
          "unit": 0.75
        },
        {
          "qty": 250,
          "unit": 0.36
        },
        {
          "qty": 500,
          "unit": 0.23
        },
        {
          "qty": 1000,
          "unit": 0.17
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"100# Cover or Text - Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "8",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.37
        },
        {
          "qty": 100,
          "unit": 0.72
        },
        {
          "qty": 250,
          "unit": 0.33
        },
        {
          "qty": 500,
          "unit": 0.2
        },
        {
          "qty": 1000,
          "unit": 0.13
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 1/0"
    },
    {
      "when": {
        "up": "8",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.4
        },
        {
          "qty": 100,
          "unit": 0.75
        },
        {
          "qty": 250,
          "unit": 0.36
        },
        {
          "qty": 500,
          "unit": 0.23
        },
        {
          "qty": 1000,
          "unit": 0.17
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 1/1"
    },
    {
      "when": {
        "up": "8",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.37
        },
        {
          "qty": 100,
          "unit": 0.72
        },
        {
          "qty": 250,
          "unit": 0.33
        },
        {
          "qty": 500,
          "unit": 0.2
        },
        {
          "qty": 1000,
          "unit": 0.14
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/0"
    },
    {
      "when": {
        "up": "8",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.41
        },
        {
          "qty": 100,
          "unit": 0.76
        },
        {
          "qty": 250,
          "unit": 0.37
        },
        {
          "qty": 500,
          "unit": 0.24
        },
        {
          "qty": 1000,
          "unit": 0.18
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/1"
    },
    {
      "when": {
        "up": "8",
        "stock": "130-cover-matte-or-gloss-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.42
        },
        {
          "qty": 100,
          "unit": 0.77
        },
        {
          "qty": 250,
          "unit": 0.38
        },
        {
          "qty": 500,
          "unit": 0.25
        },
        {
          "qty": 1000,
          "unit": 0.18
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"130# Cover - Matte or Gloss 12x18\" 4/4"
    },
    {
      "when": {
        "up": "8",
        "stock": "14pt-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.38
        },
        {
          "qty": 100,
          "unit": 0.73
        },
        {
          "qty": 250,
          "unit": 0.34
        },
        {
          "qty": 500,
          "unit": 0.21
        },
        {
          "qty": 1000,
          "unit": 0.15
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"14pt – 12x18\" 1/0"
    },
    {
      "when": {
        "up": "8",
        "stock": "14pt-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.44
        },
        {
          "qty": 100,
          "unit": 0.79
        },
        {
          "qty": 250,
          "unit": 0.4
        },
        {
          "qty": 500,
          "unit": 0.27
        },
        {
          "qty": 1000,
          "unit": 0.21
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"14pt – 12x18\" 1/1"
    },
    {
      "when": {
        "up": "8",
        "stock": "14pt-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.39
        },
        {
          "qty": 100,
          "unit": 0.74
        },
        {
          "qty": 250,
          "unit": 0.35
        },
        {
          "qty": 500,
          "unit": 0.22
        },
        {
          "qty": 1000,
          "unit": 0.16
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"14pt – 12x18\" 4/0"
    },
    {
      "when": {
        "up": "8",
        "stock": "14pt-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.45
        },
        {
          "qty": 100,
          "unit": 0.8
        },
        {
          "qty": 250,
          "unit": 0.41
        },
        {
          "qty": 500,
          "unit": 0.28
        },
        {
          "qty": 1000,
          "unit": 0.21
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"14pt – 12x18\" 4/1"
    },
    {
      "when": {
        "up": "8",
        "stock": "14pt-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.46
        },
        {
          "qty": 100,
          "unit": 0.81
        },
        {
          "qty": 250,
          "unit": 0.42
        },
        {
          "qty": 500,
          "unit": 0.29
        },
        {
          "qty": 1000,
          "unit": 0.22
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"14pt – 12x18\" 4/4"
    },
    {
      "when": {
        "up": "8",
        "stock": "16pt-12x18",
        "ink": "1/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.4
        },
        {
          "qty": 100,
          "unit": 0.75
        },
        {
          "qty": 250,
          "unit": 0.36
        },
        {
          "qty": 500,
          "unit": 0.23
        },
        {
          "qty": 1000,
          "unit": 0.16
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"16pt – 12x18\" 1/0"
    },
    {
      "when": {
        "up": "8",
        "stock": "16pt-12x18",
        "ink": "1/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.47
        },
        {
          "qty": 100,
          "unit": 0.82
        },
        {
          "qty": 250,
          "unit": 0.43
        },
        {
          "qty": 500,
          "unit": 0.3
        },
        {
          "qty": 1000,
          "unit": 0.23
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"16pt – 12x18\" 1/1"
    },
    {
      "when": {
        "up": "8",
        "stock": "16pt-12x18",
        "ink": "4/0"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.4
        },
        {
          "qty": 100,
          "unit": 0.75
        },
        {
          "qty": 250,
          "unit": 0.36
        },
        {
          "qty": 500,
          "unit": 0.23
        },
        {
          "qty": 1000,
          "unit": 0.17
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"16pt – 12x18\" 4/0"
    },
    {
      "when": {
        "up": "8",
        "stock": "16pt-12x18",
        "ink": "4/1"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.47
        },
        {
          "qty": 100,
          "unit": 0.82
        },
        {
          "qty": 250,
          "unit": 0.43
        },
        {
          "qty": 500,
          "unit": 0.3
        },
        {
          "qty": 1000,
          "unit": 0.24
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"16pt – 12x18\" 4/1"
    },
    {
      "when": {
        "up": "8",
        "stock": "16pt-12x18",
        "ink": "4/4"
      },
      "breaks": [
        {
          "qty": 50,
          "unit": 1.48
        },
        {
          "qty": 100,
          "unit": 0.83
        },
        {
          "qty": 250,
          "unit": 0.44
        },
        {
          "qty": 500,
          "unit": 0.31
        },
        {
          "qty": 1000,
          "unit": 0.25
        }
      ],
      "source": "PRINTING/Bond Price Sheet 8-Up.docx: \"16pt – 12x18\" 4/4"
    }
  ]
}
